<template>
  <div id="app">
    <div id="app-main-contain" v-cloak>
      <component :is="layout" >
        <router-view />
      </component>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap"

// Layout Components
import AnonLayout from "@/components/layouts/Anonymous.vue";
import AuthdLayout from "@/components/layouts/Authd.vue";

const default_layout = "default";
Vue.component('default-layout', AuthdLayout);
Vue.component('anon-layout', AnonLayout);

export default {
  name: 'app',
  data() {
    return {
      titleEle: document.getElementById('pageTitle'),
      defaultTitle: process.env.VUE_APP_TITLE + ' : ManhattanLife - Standing By You. Since 1850.'
    }
  },
  computed: {
    layout: function () {
        return (this.$route.meta.layout || default_layout) + '-layout';
    }
  },
  watch: {
    '$route': 'onRouteChange'
  },
  mounted() {
    this.titleEle.innerHTML = 'Welcome : ' + this.defaultTitle
  },
  methods: {
    async onRouteChange() {
      if (this.$route.name != 'callback') {
        this.titleEle.innerHTML = this.$route.meta.title + ' : ' + this.defaultTitle
      }
      await this.$store.dispatch("getPendingReports")
    },
  }
}
</script>

<style lang="scss">
#app {
  font-family: corporate-s, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
[v-cloak] { display: none; }
</style>